import { makeStyles } from '@mui/styles';

// eslint-disable-next-line import/prefer-default-export
export const useStyles = makeStyles({
    btnSub: {
        background: '#9B51E0',
        color: '#fff',
        '&:hover': {
            background: '#8A4BC6'
        }
    },

    inkBarStyle: {
        backgroundColor: '#9B51E0'
    }
});
